import client from "lib/apolloClient/client";
import {
  getLearnerPortfolioYearGroupsQuery,
  getStudentsInLearnerPortfolioYearGroupQuery,
  getLearnerPortfolioFoldersQuery,
  getLearnerPortfolioCollectionsQuery,
  getLearnerPortfolioFoldersWithCollectionsQuery,
  getLearnerPortfolioCollectionListQuery,
  getLearnerPortfolioQuery,
  getLearnerPortfolioTagsQuery,
} from "./LearnerPortfolioQuery";
import { learnerPortfolioPostFragment } from "./LearnerPortfolioFragments";

export const getLearnerPortfolioYearGroupsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioYearGroupsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentsInLearnerPortfolioYearGroupFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsInLearnerPortfolioYearGroupQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getLearnerPortfolioFoldersFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioFoldersQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getLearnerPortfolioCollectionsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioCollectionsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeLearnerPortfolioCollectionsFeedToCache = ({
  id,
  data,
  skipPostData,
  collectionFilters,
  postFilters,
}) => {
  try {
    client.writeQuery({
      query: getLearnerPortfolioCollectionsQuery,
      variables: {
        id,
        skipPostData,
        collectionFilters,
        postFilters,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getLearnerPortfolioFoldersWithCollectionsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioFoldersWithCollectionsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const readLearnerPortfolioPostFromCache = params => {
  let queryData = {};

  try {
    queryData = client.readFragment({
      id: `Post:${params?.id}`,
      fragment: learnerPortfolioPostFragment.learnerPortfolioPost,
      fragmentName: "learnerPortfolioPostItem",
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getLearnerPortfolioCollectionListFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioCollectionListQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getLearnerPortfolioFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getLearnerPortfolioTagsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearnerPortfolioTagsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};
